@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.payments.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String =
    "composeResources/mobile_wallet.feature.payments.generated.resources/"

public val Res.drawable.baseline_content_copy: DrawableResource by lazy {
      DrawableResource("drawable:baseline_content_copy", setOf(
        ResourceItem(setOf(), "${MD}drawable/baseline_content_copy.xml", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("baseline_content_copy", Res.drawable.baseline_content_copy)
}
